import React, { useMemo, useState } from 'react'
import { defineMessages, IntlProvider } from 'react-intl'
import TimeAgo from 'javascript-time-ago'
import english from 'javascript-time-ago/locale/en'
import french from 'javascript-time-ago/locale/fr'
import spanish from 'javascript-time-ago/locale/es'
import getCookie from 'utils/getCookie'
import setCookie from 'utils/setCookie'
import englishUS from 'languages/en-US'
import frenchFR from 'languages/fr-FR'
import espanolMX from 'languages/es-MX'

export const IntlContext = React.createContext({})

const messages = defineMessages({
  English: {
    ...englishUS
  },
  Spanish: {
    ...espanolMX
  },

  French: {
    ...frenchFR
  }
})

TimeAgo.addDefaultLocale(english)
TimeAgo.addLocale(french)
TimeAgo.addLocale(spanish)

export const InternationalizationProvider = ({ children }) => {
  // Map cookie/user-friendly labels to BCP-47 locale codes
  const LANGUAGE_TO_LOCALE = {
    English: 'en',
    english: 'en',
    en: 'en',
    'en-US': 'en',
    Spanish: 'es',
    spanish: 'es',
    es: 'es',
    'es-MX': 'es',
    French: 'fr',
    french: 'fr',
    fr: 'fr',
    'fr-FR': 'fr'
  }

  const initialLang = getCookie('language') || 'English'
  const [lang, setLang] = useState(initialLang)
  const localeCode = LANGUAGE_TO_LOCALE[lang] || 'en'

  const setLanguage = (language) => {
    setLang(language)
    setCookie('language', language)
  }

  const timeAgo = useMemo(() => new TimeAgo(localeCode), [localeCode])

  const contextValue = React.useMemo(() => ({
    lang,
    setLang: setLanguage,
    timeAgo
  }), [lang, timeAgo])

  return (
    <IntlContext.Provider value={contextValue}>
      <IntlProvider locale={localeCode} messages={messages[lang] || messages.English}>
        {children}
      </IntlProvider>
    </IntlContext.Provider>
  )
}

import PropTypes from 'prop-types'

InternationalizationProvider.propTypes = {
  children: PropTypes.node.isRequired
}
